import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router/index'
import vuelidate from 'vuelidate'
import 'leaflet/dist/leaflet.css';

Vue.use(vuelidate)
Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
